import React from 'react';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';

export function customToolbar(additionalActions?: React.ReactNode) {
  return (
    <GridToolbarContainer sx={{ p: '5px' }}>
      <GridToolbarQuickFilter />
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      {additionalActions}
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

export function customToolbarMinimal() {
  return (
    <GridToolbarContainer sx={{ p: '5px' }}>
      <GridToolbarQuickFilter />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}
